import { httpClient } from "@/http-client";
export default class ApiService {
  constructor() {}
  async get_element(req) {
    return httpClient({
      url: req.url,
      headers: req.headers,
    });
  }
  get_view_details(req = {}) {
    return httpClient({
      url: `views/${req.id}/${req.query ? `?${req.query}` : ""}`,
      baseURL: process.env.VUE_APP_THERM_API_HOST,
      headers: req.headers,
    });
  }
  async get_tickets_metrics(req = {}) {
    return httpClient({
      url: `metrics/${req.query ? `?${req.query}` : ""}`,
      baseURL: process.env.VUE_APP_TICKETS_API_HOST,
      headers: req.headers,
    });
  }
  async get_vault_metrics(req = {}) {
    return httpClient({
      url: `metrics/${req.query ? `?${req.query}` : ""}`,
      baseURL: process.env.VUE_APP_VAULT_API_HOST,
      headers: req.headers,
    });
  }
  async create_ticket(req = {}) {
    return httpClient({
      url: `tickets/${req.query ? `?${req.query}` : ""}`,
      baseURL: process.env.VUE_APP_TICKETS_API_HOST,
      method: "post",
      data: req.body,
      headers: req.headers,
    });
  }
  async update_issue_props(req = {}) {
    return httpClient({
      url: `element/issue/${req.issue_id}/properties/${
        req.query ? `?${req.query}` : ""
      }`,
      baseURL: process.env.VUE_APP_THERM_API_HOST,
      method: "post",
      data: req.body,
      headers: req.headers,
    });
  }
  async get(url) {
    return httpClient({
      url: url,
    });
  }
  async post(url, body) {
    return httpClient({
      url: url,
      data: body,
      baseURL: process.env.VUE_APP_THERM_API_HOST,
      method: "post",
    });
  }
  async get_claims(req = {}) {
    return httpClient({
      url: "/claims",
      baseURL: process.env.VUE_APP_CORE_API_HOST,
      headers: req.headers,
    });
  }
  async get_tickets(req = {}) {
    return httpClient({
      url: `tickets/${req.query ? `?${req.query}` : ""}`,
      baseURL: process.env.VUE_APP_TICKETS_API_HOST,
      headers: req.headers,
    });
  }
  async publish(req = {}) {
    return httpClient({
      url: `qc/projects/${req.id}/publish/${req.query ? `?${req.query}` : ""}`,
      baseURL: process.env.VUE_APP_THERM_API_HOST,
      headers: req.headers,
      method: "post",
    });
  }
  async create_tags(body) {
    return httpClient({
      url: `${process.env.VUE_APP_SID_TAGGING_SERVER}/save_project_details`,
      data: body,
      method: "post",
    });
  }
  async unpublish(req = {}) {
    return httpClient({
      url: `qc/projects/${req.id}/unpublish/${
        req.query ? `?${req.query}` : ""
      }`,
      baseURL: process.env.VUE_APP_THERM_API_HOST,
      method: "post",
      headers: req.headers,
    });
  }
  async create_elements(req = {}) {
    return httpClient({
      url: `element/bulkElementCreate/${req.query ? `?${req.query}` : ""}`,
      baseURL: process.env.VUE_APP_THERM_API_HOST,
      headers: req.headers,
      method: "post",
      data: req.body,
    });
  }
  async create_tickets(req = {}) {
    return httpClient({
      url: `tickets/therm/${req.query ? `?${req.query}` : ""}`,
      baseURL: process.env.VUE_APP_TICKETS_API_HOST,
      headers: req.headers,
      method: "post",
      data: req.body,
    });
  }
  async update_therm(req = {}) {
    return httpClient({
      url: `qc/projects/${req.id}/${req.query ? `?${req.query}` : ""}`,
      baseURL: process.env.VUE_APP_THERM_API_HOST,
      headers: req.headers,
      method: "post",
      data: req.body,
    });
  }
  get_project_details(req = {}) {
    return httpClient({
      url: `groups/${req.group_id}/projects/${req.id}/${
        req.query ? `?${req.query}` : ""
      }`,
    });
  }
  get_project_elements(req = {}) {
    return httpClient({
      url: `elements/projects/${req.id}`,
      baseURL: process.env.VUE_APP_THERM_API_HOST,
    });
  }
}
